import React from 'react';
import './tasks-skeleton.scss';

/**
 * Skeleton loading placeholder for the Tasks panel.
 * Shows ghost shapes matching the task item layout.
 */
const TasksSkeleton: React.FC = () => {
  return (
    <div className='tasks-skeleton'>
      <div className='skeleton-group'>
        <div className='skeleton-item'></div>
      </div>
    </div>
  );
};

export default TasksSkeleton;
